// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topics-preview--aaae7640{overflow:hidden;background-color:#101010;margin-bottom:3rem}@media(min-width: 768px){.topics-preview--aaae7640{padding-bottom:5rem}}.topics-preview__contents--a125d4b8{background-color:#1d1d1d}`, "",{"version":3,"sources":["webpack://./src/features/mypage/user_settings/topics/TopicsPreview.module.scss","webpack://./src/scss/_variable.scss"],"names":[],"mappings":"AAEA,0BACE,eAAA,CACA,wBAAA,CACA,kBAAA,CCcA,yBDjBF,0BAKI,mBAAA,CAAA,CAGF,oCACE,wBAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"topics-preview": `topics-preview--aaae7640`,
	"topicsPreview": `topics-preview--aaae7640`,
	"topics-preview__contents": `topics-preview__contents--a125d4b8`,
	"topicsPreview__contents": `topics-preview__contents--a125d4b8`
};
export default ___CSS_LOADER_EXPORT___;
